import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-mainnavbar',
  templateUrl: './mainnavbar.component.html',
  styleUrls: ['./mainnavbar.component.scss'],
})
export class MainnavbarComponent implements OnInit {

  name:string = 'CGSporting';

  constructor(private authService: LoginService) {

    this.name =  this.authService.getUserFromLocalDb()?.name || '';

   }

  ngOnInit() {}

}
